import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  declare inputTarget: HTMLInputElement
  declare choices: any

  async connect() {
    await import('choices.js/public/assets/styles/choices.css')
    const { default: Choices } = await import('choices.js')
    this.choices = new Choices(this.inputTarget, {
      removeItemButton: true,
      duplicateItemsAllowed: false,
      paste: true,
      searchEnabled: true,
      placeholder: true,
      loadingText: 'Lade...',
      noResultsText: 'Keine Ergebnisse gefunden',
      noChoicesText: 'Keine Auswahlmöglichkeiten',
      itemSelectText: 'Klicken um auszuwählen',
      addItemText: (value: string) => `Drücken Sie Enter um <b>"${value}"</b> hinzuzufügen`,
      maxItemText: (maxItemCount: number) => `Nur ${maxItemCount} Werte können ausgewählt werden`,
    })
    this.element['choices'] = this.choices
  }

  disconnect() {
    try {
      this.choices?.destroy()
    } catch {
      // Choices.js may fail if the DOM element was already removed
    }
    delete this.element['choices']
  }
}
